/**
 * Pasos para exportar un crucigrama
 * 1. Generar el crucigrama en https://www.educima.com/crosswordgenerator.php
 * 2. En la página que se abre, copiar del DOM el elemento con id="crossword"
 * 3. Eliminar las etiquetas <table>, <tbody>
 * 4. Sustitutir las etiquetas <td> y <td> por <div>
 * 5. Sustituir las clases 'grid-square' por 'square' y 'crossword-row' por 'row'
 * 6. Reemplazar en el elemento los siguientes atributos
 * 6.1 Reemplazar 'class' por 'className'
 * 6.2 Ajustar el 'style' en react 'style={{ textAlign: 'center' }}'
 * 6.3 Reemplazar 'maxlength="1"' por 'maxLength={1} onKeyDown={handleOnKeyDown}'
 */

import { handleOnKeyDown } from 'utils/crosswords.utils';

export const Crossword6 = (
    <div className="center crossword col-md-12" id="crossword" style={{ textAlign: 'center' }}>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="P"
                    data-num="9"
                    placeholder=""
                />
                <span className="num">1</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="M"
                    data-num="5"
                    placeholder=""
                />
                <span className="num">2</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="G"
                    data-num="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="Y"
                    data-num="5"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="7"
                    placeholder=""
                />
                <span className="num">3</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="10"
                    placeholder=""
                />
                <span className="num">4</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="1"
                    placeholder=""
                />
                <span className="num">5</span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="5"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="10"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="1"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="5"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    data-num="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="F"
                    data-num="10"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="0"
                    placeholder=""
                />
                <span className="num">6</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="0"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="V"
                    data-num="1"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="V"
                    data-num="5"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="M"
                    data-num="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="10"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="1"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="5"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    data-num="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="V"
                    data-num="2"
                    placeholder=""
                />
                <span className="num">7</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="10"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="2"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="2"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="2"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="2"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="2"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="2"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="2"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    data-num="5"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="10"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    data-num="1"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="5"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="10"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="M"
                    data-num="4"
                    placeholder=""
                />
                <span className="num">8</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    data-num="4"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="4"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="4"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="5"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="Ó"
                    data-num="10"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="F"
                    data-num="1"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="5"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="10"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="1"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="Ó"
                    data-num="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="3"
                    placeholder=""
                />
                <span className="num">9</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="3"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="3"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="H"
                    data-num="3"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="3"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="B"
                    data-num="6"
                    placeholder=""
                />
                <span className="num">10</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    data-num="3"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="3"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="3"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="1"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="6"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="1"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="6"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="6"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="6"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="G"
                    data-num="8"
                    placeholder=""
                />
                <span className="num">11</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="8"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    data-num="8"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="P"
                    data-num="8"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="8"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="8"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="6"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="M"
                    data-num="11"
                    placeholder=""
                />
                <span className="num">12</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="11"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="11"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="12"
                    placeholder=""
                />
                <span className="num">13</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="H"
                    data-num="11"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="11"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="11"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="12"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="12"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="P"
                    data-num="12"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="12"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="13"
                    placeholder=""
                />
                <span className="num">14</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="W"
                    data-num="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="F"
                    data-num="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    data-num="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="G"
                    data-num="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="M"
                    data-num="12"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="12"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="12"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="12"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="12"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="14"
                    placeholder=""
                />
                <span className="num">15</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="14"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="V"
                    data-num="14"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="14"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="14"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="14"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="14"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
    </div>
);
